import "core-js/modules/es.array.push.js";
export function gtag() {
  var _window;
  for (var _len = arguments.length, _ = new Array(_len), _key = 0; _key < _len; _key++) {
    _[_key] = arguments[_key];
  }
  if (typeof window === "undefined" || !((_window = window) !== null && _window !== void 0 && (_window = _window.dataLayer) !== null && _window !== void 0 && _window.push)) return;
  // Must be using 'arguments' & non-arrow function to push the callback into dataLayer
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}